'use client'

const clientConfig = {
  tolgeeApiKey: process.env.NEXT_PUBLIC_TOLGEE_API_KEY || '',
  tolgeeApiUrl: process.env.NEXT_PUBLIC_TOLGEE_API_URL || '',
} as const
export const IMAGEKIT_ID = process.env.NEXT_PUBLIC_IMAGEKIT_ID || '7rwv4wy3sq0'
export const GA_TRACKING_ID = process.env.NEXT_PUBLIC_GA_TRACKING_ID
export const ADWORDS_CONVERSION_ID =
  process.env.NEXT_PUBLIC_ADWORDS_CONVERSION_ID
export const SG_ODDLE_EATS_GA_TRACKING_ID =
  process.env.NEXT_PUBLIC_SG_ODDLE_EATS_GA_TRACKING_ID
export const SG_ODDLE_EATS_AW_TRACKING_ID =
  process.env.NEXT_PUBLIC_SG_ODDLE_EATS_AW_TRACKING_ID
export const SG_ODDLE_EATS_PIXEL_ID =
  process.env.NEXT_PUBLIC_SG_ODDLE_EATS_PIXEL_ID
export const FACEBOOK_PIXEL_ID = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID
export const GTM_CONTAINER_ID = process.env.NEXT_PUBLIC_GTM_CONTAINER_ID
export const SEGMENT_API_KEY = process.env.NEXT_PUBLIC_SEGMENT_API_KEY

export const ODDLE_PASS_CLIENT_ID = process.env.NEXT_PUBLIC_ODDLE_PASS_CLIENT_ID
export const ODDLE_PASS_JS_URL = process.env.NEXT_PUBLIC_ODDLE_PASS_JS_URL
export const ODDLE_PASS_REDIRECT_URL =
  process.env.NEXT_PUBLIC_ODDLE_PASS_REDIRECT_URL

const FE_CORE_STATIC_PATH = '/static'

export const coreResource = (path: string) =>
  `${FE_CORE_STATIC_PATH}${path || ''}`

export const DEFAULT_PRODUCT_IMAGE_URL = coreResource(
  '/images/default-product.png'
)

export const ID_OFFSET = 4
export const READABLE_ID_MAX_LENGTH = 1500 // NOTE: Max URL length is 2048: https://stackoverflow.com/questions/417142/what-is-the-maximum-length-of-a-url-in-different-browsers
export const DEFAULT_LOCALE = 'en_SG'
export const NR_BROWSER_APP_ID =
  process.env.NEXT_PUBLIC_NR_BROWSER_APP_ID || '1120384148'
export const DEFAULT_MAX_DAYS_PICKER_SETTING = 80

export default clientConfig

export const defaultImageSource = coreResource(
  '/images/slideshow-banner-withText.png'
)
